import { render, staticRenderFns } from "./FeeReview.vue?vue&type=template&id=7975f658&scoped=true&"
import script from "./FeeReview.vue?vue&type=script&lang=js&"
export * from "./FeeReview.vue?vue&type=script&lang=js&"
import style0 from "./FeeReview.vue?vue&type=style&index=0&id=7975f658&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7975f658",
  null
  
)

component.options.__file = "FeeReview.vue"
export default component.exports